import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { DialogContextType } from "../../DialogComponents/FullScreenDialog";

export const useContext = (): DialogContextType => {
  const { t } = useTranslation("common");

  return useMemo(
    () => ({
      title: {
        icon: "key",
      },
      applyText: t("actions.save"),
    }),
    [t],
  );
};
